import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleError, handleResponse } from 'src/functions/http-handler';
import { PrintService } from './print.service';
import { FileSaverService } from 'ngx-filesaver';
import { catchError, map, tap } from 'rxjs/operators';
import { IResponse } from 'src/models/response.model';
import { IProductPlanDetail } from 'src/services/product-plan.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsignedMaterialProductPlanService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private fileSaver: FileSaverService,
    private printSvc: PrintService,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/ConsignedMaterialProductPlan`;
  }

  get(criteria: any) {
    return this.http.get(this._apiUrl, { params: criteria })
      .pipe(
        tap((res) => this.logger.log('retrieve consigned-material product-plan', res)),
        catchError(handleError),
        map((data: IResponse) => {
          if (data.code == 'NoData') {
            return [];
          } else {
            return data.result;
          }
        })
      );
  }  

  export(param: any, type: 'sheet' | 'pdf') {
    const mimeType = (type == 'sheet') ? environment.mimeTypes.excel : environment.mimeTypes.pdf;
    const extension = (type == 'sheet') ? '.xlsx' : '.pdf';

    return this.http.get(`${this._apiUrl}/Export`, {
      headers: { 'Accept': mimeType },
      responseType: 'blob', // This must be a Blob type
      params: param
    }).subscribe((res: Blob) => {
      var filename = `ConsignedMaterialProductPlan${extension}`;
      this.saveAsBlob(res, filename, mimeType);
    })
  }

  private saveAsBlob(data: any, filename: string, mimeType: string) {
    const file = new File([data], filename, { type: mimeType });
    this.fileSaver.save(file, filename);
  }
}

export interface IConsignedMaterialProductPlan {  
  itemId: string,
  consumption: number,
  plans: Array<IProductPlanDetail>,
}